import { classes } from "@tm/utils"
import { forwardRef } from "react"
import { Box, BoxProps, styled } from "@mui/material"
import { offerItemClasses, offerItemName, offerItemSlots } from "@tm/themes"

const OfferItemErpPricesComponent = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
    <Box {...props} className={classes(offerItemClasses.erpPrices, props.className)} ref={ref} />
))
export const OfferItemErpPrices = styled(OfferItemErpPricesComponent, {
    name: offerItemName,
    slot: offerItemSlots.erpPrices,
    overridesResolver: (_, styles) => styles.erpPrices,
})({
    ".tk-erp .erp-info-prices .price__group": {
        alignItems: "flex-End",
        marginRight: 0,
        minWidth: 0,
        ".price__value": {
            whiteSpace: "nowrap",
        },
        "&--two-column:first-child .price--info-only": {
            alignSelf: "unset",
        },
    },
    height: 53,
})
